import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  available: false,
};

const todoistSlice = createSlice({
  name: 'todoist',
  initialState,
  reducers: {
    todoistReceived(state, action) {
      return { ...action.payload };
    },
    todoistError() {
      return { available: false };
    },
  },
});

export const { todoistReceived, todoistError } = todoistSlice.actions;

export const getTodoistTask = () => dispatch => {
  const url = 'https://wonder.kevinvandertoorn.com/octo-dashboard/api/todoist-task/';

  const request = () => {
    axios
      .get(url)
      .then(({ data }) => {
        dispatch(todoistReceived(data));
      })
      .catch(() => {
        dispatch(todoistError());
      });
  };

  request();
};

export default todoistSlice.reducer;


